module.exports = __webpack_public_path__ + "img/shield-exclamation.555afe98.svg";